module.exports = __webpack_public_path__ + "img/sustainable_city.50b7ceb9.png";